<template>
  <dv-decoration-3 class="decoration-container" :color="color"></dv-decoration-3>
</template>
<script>
import { decoration3 } from '@jiaminghi/data-view'
import Vue from 'vue'
import Minin from './mixin'
Vue.use(decoration3)
export default {
  name: 'Decoration3',
  mixins: [Minin]
}
</script>
<style lang="less" scoped>
  .decoration-container{
    width: 100%;
    height: 100%;
  }
</style>